import { ATextInput, ATextInputBaseProps } from '../inputs';

export interface ALoginNameInputProps extends ATextInputBaseProps<string> {}

export default function ALoginNameInput(props: ALoginNameInputProps) {
    // NOTE: Only ASCII chars are accepted
    return <ATextInput {...props} maxLength={128} minLength={4} regExp={/^[\x00-\x7F]+$/} />;
}
